export const clearWhiteSpace = ({ str }) => str.replace(/\s+/g, '')
